import { combineReducers } from 'redux';

import {
  INVENTORY_TRANSFER_RESET_STATE,
  INVENTORY_TRANSFER_SET_TRANSFERS,
  INVENTORY_TRANSFER_SET_TRANSFER_DETAIL,
  INVENTORY_TRANSFER_SET_OUTLETS,
  INVENTORY_TRANSFER_SET_CURRENT_PAGE,
  INVENTORY_TRANSFER_SET_TOTAL_PAGE,
  INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN,
  INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN,
  INVENTORY_TRANSFER_SET_SELECTED_OUTLETS,
  INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM,
  INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL,
  INVENTORY_TRANSFER_SET_ADD_ITEMS,
  INVENTORY_TRANSFER_RESET_ADD_ITEMS,
  INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING,
  INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL,
  INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL,
  INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED,
  INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT,
  INVENTORY_TRANSFER_EXPORT_START,
  INVENTORY_TRANSFER_EXPORT_DONE,
  INVENTORY_TRANSFER_SET_ASYNCJOBID,
} from 'actions/inventory/transfer/constants';

import createReducer from 'utils/createReducer';

const addItems = createReducer(
  {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0,
  },
  {
    [INVENTORY_TRANSFER_SET_ADD_ITEMS]: (draft, { payload }) =>
      payload.addItems,

    [INVENTORY_TRANSFER_RESET_ADD_ITEMS]: () => ({
      items: [],
      itemOptions: [],
      currentPage: 0,
      totalPage: 0,
    }),
  }
);

const confirmCreateButtonStatus = createReducer(false, {
  [INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS]: (draft, { payload }) =>
    payload.isClicked,
});

const currentPage = createReducer(null, {
  [INVENTORY_TRANSFER_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

const exportButtonStatus = createReducer(true, {
  [INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS]: (draft, { payload }) =>
    payload.exportButtonStatus,
});

const idAsyncJob = createReducer(null, {
  [INVENTORY_TRANSFER_SET_ASYNCJOBID]: (draft, { payload }) =>
    payload.idAsyncJob,
});

const isExportLoading = createReducer(false, {
  [INVENTORY_TRANSFER_EXPORT_START]: () => true,
  [INVENTORY_TRANSFER_EXPORT_DONE]: () => false,
});

const isItemAlreadyAdded = createReducer(false, {
  [INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED]: (draft, { payload }) =>
    payload.isItemAlreadyAdded,
});

const itemOptionIsLoading = createReducer(false, {
  [INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING]: (draft, { payload }) =>
    payload.itemOptionIsLoading,
});

const openRightColumn = createReducer(false, {
  [INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN]: () => true,
  [INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [INVENTORY_TRANSFER_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const searchItemsInit = createReducer(
  {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0,
  },
  {
    [INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT]: (draft, { payload }) =>
      payload.itemInit,
  }
);

const selectedOutlets = createReducer([], {
  [INVENTORY_TRANSFER_SET_SELECTED_OUTLETS]: (draft, { payload }) =>
    payload.selectedOutlets,
});

const showAddItemsModal = createReducer(false, {
  [INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM]: () => true,
  [INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL]: () => false,
  [INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL]: () => false,
});

const showConfirmSubmitModal = createReducer(false, {
  [INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL]: (draft, { payload }) =>
    payload.isShowConfirmSubmitModal,
});

const totalPage = createReducer(null, {
  [INVENTORY_TRANSFER_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

const transferDetail = createReducer(null, {
  [INVENTORY_TRANSFER_SET_TRANSFER_DETAIL]: (draft, { payload }) =>
    payload.transfer,
});

const transfers = createReducer([], {
  [INVENTORY_TRANSFER_SET_TRANSFERS]: (draft, { payload }) => payload.transfers,
});

const reducer = combineReducers({
  addItems,
  confirmCreateButtonStatus,
  currentPage,
  exportButtonStatus,
  idAsyncJob,
  isExportLoading,
  isItemAlreadyAdded,
  itemOptionIsLoading,
  openRightColumn,
  outlets,
  searchItemsInit,
  selectedOutlets,
  showAddItemsModal,
  showConfirmSubmitModal,
  totalPage,
  transferDetail,
  transfers,
});

// FIXME This custom reducer is needed because `INVENTORY_TRANSFER_RESET_STATE`
// is resetting only a fixed amount of properties.
// This is probably not intended but definitely need verification.
function customAndDoNotEverDoThisInTheFutureReducer(state, action) {
  // 'INVENTORY_TRANSFER_RESET_STATE' is not resetting state entirely
  if (action.type === INVENTORY_TRANSFER_RESET_STATE) {
    return {
      ...state,
      confirmCreateButtonStatus: false,
      idAsyncJob: null,
      isExportLoading: false,
      outlets: [],
      selectedOutlets: [],
      transfers: [],
      openRightColumn: false,
      transferDetail: null,
      currentPage: null,
      totalPage: null,
      showAddItemsModal: false,
      showConfirmSubmitModal: false,
      itemOptionIsLoading: false,
      isItemAlreadyAdded: false,
      addItems: {
        items: [],
        itemOptions: [],
        currentPage: 0,
        totalPage: 0,
      },
      exportButtonStatus: true,
      searchItemsInit: {
        items: [],
        itemOptions: [],
        currentPage: 0,
        totalPage: 0,
      },
    };
  }

  // For other actions, use the composed reducer
  return reducer(state, action);
}

export default customAndDoNotEverDoThisInTheFutureReducer;
